import { makeStyles } from "@material-ui/core/styles";
import theme from "../../theme";

export const useStyles = makeStyles(() => ({
  conteudo: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  titulo: {
    "&.MuiTypography-root": {
      fontSize: 20,
      color: theme.palette.text.primary,
      fontWeight: 600,
      marginTop: "10px",
    },
  },
  subtitulo: {
    "&.MuiTypography-root": {
      fontSize: 16,
      color: "#657487",
      marginTop: "15px",
    },
  },
  containerStatus: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "20px",
  },
  textoStatus: {
    "&.MuiTypography-root": {
      fontSize: 15,
      fontWeight: 600,
    },
  },
  statusAguardando: {
    "&.MuiTypography-root": {
      color: "#B78105",
    },
  },
  statusErro: {
    "&.MuiTypography-root": {
      color: "#D32F2F",
    },
  },
  containerQrCode: {
    marginTop: "25px",
    padding: "15px",
    backgroundColor: "#FFF",
    borderRadius: "8px",
    border: "1px solid #E0E0E0",
  },
  imagemQrCode: {
    width: "220px",
    height: "220px",
    objectFit: "contain",
  },
  infoValor: {
    "&.MuiTypography-root": {
      fontSize: 18,
      color: theme.palette.text.primary,
      fontWeight: 600,
      marginTop: "20px",
    },
  },
  infoDetalhe: {
    "&.MuiTypography-root": {
      fontSize: 16,
      color: "#657487",
      marginTop: "10px",
    },
  },
  instrucao: {
    "&.MuiTypography-root": {
      fontSize: 14,
      color: "#657487",
      marginTop: "25px",
      maxWidth: "400px",
    },
  },
  tituloComprovante: {
    "&.MuiTypography-root": {
      fontSize: 20,
      color: theme.palette.text.primary,
      marginTop: "20px",
    },
  },
  subtituloComprovante: {
    "&.MuiTypography-root": {
      fontSize: 18,
      color: "#657487",
      marginTop: "20px",
    },
  },
  containerImages: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    marginTop: "20px",
  },
}));
